<div id="confirmation" data-cy="confirmation">
  <div class="form" [formGroup]="control" class="container mx-auto">
    <ife-title
      [title]="'modules.evcQuote.steps.confirmation.title' | translate"
      [subtitle]="'modules.evcQuote.steps.confirmation.description' | translate"
      data-cy="confirmation-title"
    ></ife-title>

    <div class="description">
      <div
        class="block text-primary text-center mt-8"
        [innerHTML]="'modules.evcQuote.steps.confirmation.info' | translate"
      ></div>

      <!-- The whole checkbox container is clickable -->
      <!-- And for this reason the pointer-events need to be set to none, so the input doesn't cause double click -->
      <div class="bg-white rounded-4xl p-8 max-w-4xl mx-auto my-16" (click)="toggleCheckbox()">
        <div class="inline-block">
          <div class="form-element input-checkbox">
            <input
              id="newsletter"
              type="checkbox"
              formControlName="newsletter"
              data-cy="checkbox-newsletter"
              style="pointer-events: none"
            />
            <label class="text-left" [innerHTML]="'modules.evcQuote.steps.confirmation.newsletter' | translate">
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="navigation max-w-3xl">
      <button class="btn-primary navigate-next" (click)="submit()">
        {{ 'modules.evcQuote.steps.confirmation.ctaButton' | translate }}
      </button>
    </div>
    <ife-navigation
      class="navigate-back"
      [showNext]="false"
      [showPrevious]="true"
      (nextStep)="navigate()"
      (previousStep)="navigateBack()"
    >
    </ife-navigation>
  </div>

  <!-- Extra page info -->
  <div class="bg-white p-8 py-16 mt-28 flex-grow">
    <ife-title
      [title]="'modules.evSimulator.steps.personalCalculation.flow.title' | translate"
      data-cy="flow-title"
    ></ife-title>
    <swiper-container
      id="swiper"
      class="flow-steps flex m-auto"
      data-cy="swiper"
      appSwiper
      #swiper
      [config]="swiperConfig"
      init="false"
    >
      <swiper-slide class="flow-steps--step" *ngFor="let index of slidesIterator">
        <div class="flow-steps--step-image">
          <img
            [src]="'./assets/evc/img/flow-' + index + '.png'"
            [alt]="'modules.evSimulator.steps.personalCalculation.flow.step' + index + '.title' | translate"
          />
          <span>{{ index }}</span>
        </div>
        <span
          class="flow-steps--step-title"
          [innerHTML]="'modules.evSimulator.steps.personalCalculation.flow.step' + index + '.title' | translate"
        ></span>
        <span
          [innerHTML]="'modules.evSimulator.steps.personalCalculation.flow.step' + index + '.description' | translate"
        ></span>
        <div *ngIf="index !== 4" class="flow-steps--line"></div>
      </swiper-slide>
    </swiper-container>
  </div>
</div>
